import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Footer() {
  let date = new Date();
  let year = date.getFullYear();
  return (
    <Container fluid className="footer">
      <Row>
        <Col md="4" className="footer-copywright">
          <h3>Designed and Developed by Chetan Sharma</h3>
        </Col>
        <Col md="4" className="footer-copywright">
          <h3>Copyright © {year} CS</h3>
        </Col>
        <Col md="4" className="footer-body">
          <ul className="footer-icons">
            <li className="social-icons">
              <a
                href="https://github.com/TranceOp"
                style={{ color: "white" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <AiFillGithub />
              </a>
            </li>
            <li className="social-icons">
              <a
                                href="https://github.com/TranceOp"
                                target="_blank"
                                rel="noreferrer"
                                className="icon-colour  home-social-icons"
                              >
                                <AiFillGithub />
                              </a>
                            </li>
                            <li className="social-icons">
                              <a
                                href="https://twitter.com/"
                                target="_blank"
                                rel="noreferrer"
                                className="icon-colour  home-social-icons"
                              >
                                <AiOutlineTwitter />
                              </a>
                            </li>
                            <li className="social-icons">
                              <a
                                href="https://www.linkedin.com/in/chetan-sharma-7a12011b8/"
                                target="_blank"
                                rel="noreferrer"
                                className="icon-colour  home-social-icons"
                              >
                                <FaLinkedinIn />
                              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://www.instagram.com/__chetan._0_7_/?igsh=MXczYmM0OGJ3ZXUzeg%3D%3D&utm_source=qr#"
                style={{ color: "white" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <AiFillInstagram />
              </a>
            </li>
          </ul>
        </Col>
      </Row>
    </Container>
  );
}

export default Footer;
